module.exports = __webpack_public_path__ + "img/money.6e0d840d.svg";